import axios from 'axios';
import apiConfig from '../config/apiConfig';

const BASE_URL = apiConfig.BASE_URL;

function getStoredToken() {
  try {
    const persistRoot = localStorage.getItem('persist:root');
    if (persistRoot) {
      const parsed = JSON.parse(persistRoot);
      if (parsed.auth) {
        const authState = JSON.parse(parsed.auth);
        return authState.token;
      }
    }
  } catch (e) {
    console.warn('Could not read token from redux-persist:', e);
  }
  return localStorage.getItem('storehub_token') || sessionStorage.getItem('storehub_token');
}

function getAuthHeaders() {
  const token = getStoredToken();
  if (!token || token === 'null' || token === 'undefined') {
    throw new Error('Authentication required. Please log in again.');
  }
  return { headers: { Authorization: 'Bearer ' + token } };
}

export const fetchTasks = async (params) => {
  const auth = getAuthHeaders();
  const response = await axios.get(BASE_URL + '/api/tasks', { ...auth, params: params || {} });
  return response.data;
};

export const fetchTaskStats = async () => {
  const auth = getAuthHeaders();
  const response = await axios.get(BASE_URL + '/api/tasks/stats', auth);
  return response.data;
};

export const getTaskById = async (id) => {
  const auth = getAuthHeaders();
  const response = await axios.get(BASE_URL + '/api/tasks/' + id, auth);
  return response.data;
};

export const createTask = async (payload) => {
  const auth = getAuthHeaders();
  const response = await axios.post(BASE_URL + '/api/tasks', payload, auth);
  return response.data;
};

export const updateTask = async (id, payload) => {
  const auth = getAuthHeaders();
  const response = await axios.put(BASE_URL + '/api/tasks/' + id, payload, auth);
  return response.data;
};

export const deleteTask = async (id) => {
  const auth = getAuthHeaders();
  await axios.delete(BASE_URL + '/api/tasks/' + id, auth);
  return id;
};
